/**
 * 推薦碼 LocalStorage 管理工具
 * 用於跨錢包識別推薦人
 */

import { logger } from './logger'

const STORAGE_KEY = 'bentana_referral_code'
const STORAGE_TIMESTAMP_KEY = 'bentana_referral_stored_at'

export interface ReferralStorage {
  code: string
  storedAt: string
}

/**
 * 保存推薦碼到 LocalStorage
 */
export function saveReferralCode(code: string): boolean {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      logger.warn('LocalStorage 不可用')
      return false
    }

    // 驗證推薦碼格式（6-8 位字母數字）
    if (!/^[A-Z0-9]{6,8}$/.test(code)) {
      logger.warn('推薦碼格式無效')
      return false
    }

    localStorage.setItem(STORAGE_KEY, code.toUpperCase())
    localStorage.setItem(STORAGE_TIMESTAMP_KEY, new Date().toISOString())
    
    // 推薦碼已保存
    return true
  } catch (error) {
    logger.error('保存推薦碼失敗:', error)
    return false
  }
}

/**
 * 從 LocalStorage 讀取推薦碼
 */
export function getReferralCode(): string | null {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null
    }

    const code = localStorage.getItem(STORAGE_KEY)
    return code ? code.toUpperCase() : null
  } catch (error) {
    logger.error('讀取推薦碼失敗:', error)
    return null
  }
}

/**
 * 獲取推薦碼存儲信息
 */
export function getReferralStorage(): ReferralStorage | null {
  try {
    const code = getReferralCode()
    if (!code) return null

    const storedAt = localStorage.getItem(STORAGE_TIMESTAMP_KEY) || new Date().toISOString()
    
    return {
      code,
      storedAt
    }
  } catch (error) {
    logger.error('獲取推薦碼存儲信息失敗:', error)
    return null
  }
}

/**
 * 清除推薦碼
 */
export function clearReferralCode(): boolean {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return false
    }

    localStorage.removeItem(STORAGE_KEY)
    localStorage.removeItem(STORAGE_TIMESTAMP_KEY)
    
    // 推薦碼已清除
    return true
  } catch (error) {
    logger.error('清除推薦碼失敗:', error)
    return false
  }
}

/**
 * 檢查推薦碼是否存在
 */
export function hasReferralCode(): boolean {
  return getReferralCode() !== null
}

